export const IMAGESTYPES = 'image/*';
export const VIDEOTYPES = 'video/mp4,video/x-m4v,audio/mp3,m4a';
export const FILETYPES = '.pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .csv';

export const MAX_IMAGE_SIZE = 20;
export const MAX_VIDEO_SIZE = 200;
export const MAX_FILE_SIZE = 20;

export const IMAGE_EXTENSIONS = [
    '.exr',
    '.apng',
    '.avci',
    '.avcs',
    '.avif',
    '.bmp',
    '.cgm',
    '.drle',
    '.emf',
    '.fits',
    '.g3',
    '.gif',
    '.heic',
    '.heics',
    '.heif',
    '.heifs',
    '.hej2',
    '.hsj2',
    '.ief',
    '.jls',
    '.jp2',
    '.jpg2',
    '.jpeg',
    '.jpg',
    '.jpe',
    '.jph',
    '.jhc',
    '.jpm',
    '.jpx',
    '.jpf',
    '.jxr',
    '.jxra',
    '.jxrs',
    '.jxs',
    '.jxsc',
    '.jxsi',
    '.jxss',
    '.ktx',
    '.ktx2',
    '.png',
    '.btif',
    '.pti',
    '.sgi',
    '.svg',
    '.svgz',
    '.t38',
    '.tif',
    '.tiff',
    '.tfx',
    '.psd',
    '.azv',
    '.uvi',
    '.uvvi',
    '.uvg',
    '.uvvg',
    '.djvu',
    '.djv',
    '.sub',
    '.dwg',
    '.dxf',
    '.fbs',
    '.fpx',
    '.fst',
    '.mmr',
    '.rlc',
    '.ico',
    '.dds',
    '.mdi',
    '.wdp',
    '.npx',
    '.b16',
    '.tap',
    '.vtf',
    '.wbmp',
    '.xif',
    '.pcx',
    '.webp',
    '.wmf',
    '.3ds',
    '.ras',
    '.cmx',
    '.fh',
    '.fhc',
    '.fh4',
    '.fh5',
    '.fh7',
    '.jng',
    '.sid',
    '.pbm',
    '.pnm',
    '.pgm',
    '.ppm',
    '.rgb',
    '.tga',
    '.xbm',
    '.xpm',
    '.xwd',
];

export const REMINDER_SET = {
    // Hourly: [
    // 	{ label: '15 Minutes', value: '15mins' },
    // 	{ label: '30 Minutes', value: '30mins' },
    // ],a
    Daily: [
        { label: '15 Minutes', value: '15mins' },
        { label: '30 Minutes', value: '30mins' },
        { label: '1 hour', value: '1hour' },
    ],
    Weekly: [
        { label: '15 Minutes', value: '15mins' },
        { label: '30 Minutes', value: '30mins' },
        { label: '1 hour', value: '1hour' },
        { label: '1 day', value: '1day' },
    ],
    Monthly: [
        { label: '15 Minutes', value: '15mins' },
        { label: '30 Minutes', value: '30mins' },
        { label: '1 hour', value: '1hour' },
        { label: '1 day', value: '1day' },
        { label: '1 week', value: '7days' },
    ],
    Quarterly: [
        { label: '15 Minutes', value: '15mins' },
        { label: '30 Minutes', value: '30mins' },
        { label: '1 hour', value: '1hour' },
        { label: '1 day', value: '1day' },
        { label: '1 week', value: '7days' },
        { label: '1 month', value: '30days' },
    ],
    Halfyearly: [
        { label: '15 Minutes', value: '15mins' },
        { label: '30 Minutes', value: '30mins' },
        { label: '1 hour', value: '1hour' },
        { label: '1 day', value: '1day' },
        { label: '1 week', value: '7days' },
        { label: '1 month', value: '30days' },
    ],
    Yearly: [
        { label: '15 Minutes', value: '15mins' },
        { label: '30 Minutes', value: '30mins' },
        { label: '1 hour', value: '1hour' },
        { label: '1 day', value: '1day' },
        { label: '1 week', value: '7days' },
        { label: '1 month', value: '30days' },
    ],
    All: [
        { label: '15 Minutes', value: '15mins' },
        { label: '30 Minutes', value: '30mins' },
        { label: '1 hour', value: '1hour' },
        { label: '1 day', value: '1day' },
        { label: '1 week', value: '7days' },
        { label: '1 month', value: '30days' },
    ],
};
